/**
 * Pillar definitions — matches the DEFAULT_DATA structure in the existing
 * q2-goals.html (around line 387), minus the `goals` array for now.
 *
 * When we port individual pillars in future sessions, each pillar's goals
 * will move into its own component file (src/pillars/XxxPillar.jsx), with
 * the goal data fetched from the same KV store the live dashboard uses.
 *
 * For now, this array drives the pillar tab navigation.
 */
export const PILLARS = [
  {
    id: 'eo-buyouts',
    name: 'EO Buyouts',
    icon: '🔄',
    color: '#ea580c',
    goalCount: 3,
  },
  {
    id: 'revenue',
    name: 'Revenue',
    icon: '💰',
    color: '#16a34a',
    goalCount: 1,
  },
  {
    id: 'growth',
    name: 'Growth',
    icon: '📈',
    color: '#2563eb',
    // Bumped to include the former Delivery & Product goals (merged
    // in 2026-04-21). The count is approximate — the actual number
    // comes from goals data — but helps the tab label reflect reality.
    goalCount: 15,
  },
  {
    id: 'team',
    name: 'Team & Culture',
    icon: '🤝',
    color: '#d97706',
    goalCount: 7,
  },
  {
    id: 'ai',
    name: 'AI Systems',
    icon: '🤖',
    color: '#0891b2',
    goalCount: 3,
  },
  {
    id: 'team-updates',
    name: 'Team Updates',
    icon: '📣',
    color: '#7c3aed',
    // Not goal-driven — this is team-level narrative (TLDR / Wins /
    // Flags) per team DRI, feeding the executive summary.
    goalCount: 3,
  },
  {
    id: 'scorecard',
    name: 'Scorecard',
    icon: '🎯',
    color: '#0f766e',
    // Synthetic pillar — no goals of its own. Reads goal.status across
    // every other pillar and rolls them up into a "what to discuss in
    // this week's review" view. Placed last so the natural flow is:
    // pillars → team updates → scorecard recap.
    goalCount: 0,
  },
]

/**
 * Q2 2026 date boundaries — used by the countdown timer and progress bars.
 */
export const Q2_START = new Date('2026-04-01T00:00:00')
export const Q2_END = new Date('2026-07-01T00:00:00')
